import { render, staticRenderFns } from "./WettkampfListe.vue?vue&type=template&id=0eaf8ce4&scoped=true&"
import script from "./WettkampfListe.vue?vue&type=script&lang=js&"
export * from "./WettkampfListe.vue?vue&type=script&lang=js&"
import style0 from "./WettkampfListe.vue?vue&type=style&index=0&id=0eaf8ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaf8ce4",
  null
  
)

export default component.exports